import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import success from '../../../assets/images/backoffice/kyc6.png';
import wallet from '../../../assets/icons/backOffice/Packages/wallet.svg';
import { CreditCard } from '../../../components/common/CreditCard';
import { Hub } from '../../../components/common/Hub/Hub';
import {
  copyLink,
  dateDifferenceInDaysFromToday,
  formatUSD,
  showNetworkType,
  showTokenType,
  USDT
} from '../../../helpers/helperFunctions';
import { ORDERS } from '../../../routes/routes';
import {
  CaptionText,
  H2,
  H3,
  P3,
  P1,
  H4,
  P2
} from '../../../styles/FontStyles';
import { Button, Flexed, SelectedUSDT } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconCopy } from '../../../styles/Icons';
import { NetworkType, WalletsType } from '../../../types/types';

import { Node } from '../../../components/common/Node/Node';
import { SelectNetwork } from '../../../components/common/SelectNetwork/SelectNetwork';
import { Dispatch, SetStateAction } from 'react';
import { SelectToken } from '../../../components/common/SelectNetwork/SelectToken';

interface SuccessProps {
  selectedPackage: any;
  selectedLicence: any;
  setSelectedNetwork: Dispatch<SetStateAction<WalletsType>>;
  selectedNetwork: WalletsType;
  selectedToken: any;
  setSelectedToken: Dispatch<SetStateAction<any>>;
}

export const Success = ({
  selectedPackage,
  selectedLicence,
  setSelectedNetwork,
  selectedNetwork,
  setSelectedToken,
  selectedToken
}: SuccessProps) => {
  const { t } = useTranslation('marketplace');
  const history = useHistory();

  const { userInfo } = useAppSelector((state) => state.auth);
  const { userPackage } = useAppSelector((state) => state.marketplace);

  const licenceDate = dateDifferenceInDaysFromToday(
    userInfo.user.currentVirtualOfficeLicence?.dateEnd
  );

  const amountToPay = selectedLicence
    ? selectedPackage?.subscriptionPrice
      ? selectedLicence.price +
        selectedPackage?.price +
        selectedPackage?.subscriptionPrice
      : selectedLicence.price + selectedPackage?.price
    : selectedPackage?.subscriptionPrice
    ? selectedPackage?.subscriptionPrice + selectedPackage?.price
    : selectedPackage?.price;

  return (
    <div>
      <P1 bold mb='20' center style={{ fontFamily: 'Nulshock' }}>
        YOUR ORDER:
      </P1>
      <P2 center>
        To complete the order please send the funds to the dedicated wallet
        address below.
      </P2>
      <P2 center bold mb='20'>
        Payment instructions were also sent on your email.
      </P2>
      <Node
        key={selectedPackage?.id}
        condensed
        showTickets={false}
        image={selectedPackage?.imageUrl}
        title={selectedPackage?.name}
        price={selectedPackage?.price}
        packagePrice={selectedPackage?.price}
        info={<></>}
      />
      {selectedLicence && (
        <Flexed between center mb='40' ml='90' mr='90'>
          <div>
            <H4 bold center>
              Backoffice licence{' '}
            </H4>

            <P3>
              {selectedLicence?.title} {selectedLicence?.title2}
            </P3>
          </div>
          <H4 bold center>
            {selectedLicence?.price} USDT
          </H4>
        </Flexed>
      )}

      <P2 center>Make sure that you are sending</P2>
      <P2 center bold mb='20'>
        total amount in USDT or USDC on <br />
        Binance Smart Chain
      </P2>
      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        Total Amount
      </P3>
      <SelectedUSDT>
        {formatUSD(amountToPay)}
        <div>USDT/USDC</div>
      </SelectedUSDT>
      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        Blockchain Network
      </P3>
      <SelectNetwork
        disabled
        onChange={(n) => setSelectedNetwork(n)}
        value={selectedNetwork}
      />
      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        Wallet Address
      </P3>
      <SelectedUSDT
        onClick={() => {
          copyLink(
            selectedPackage?.paymentAddress,
            'The wallet address has been copied'
          );
        }}
        style={{ cursor: 'pointer' }}>
        <div className='truncated'>
          <div>{userPackage?.paymentAddress}</div>
        </div>

        <img
          src={wallet}
          alt='withdraw'
          style={{ width: 16, marginLeft: 10 }}
        />
      </SelectedUSDT>
      <Button
        mt={20}
        onClick={() => {
          history.push(ORDERS);
        }}>
        Continue
      </Button>
    </div>
  );
};
